import moment from 'moment-timezone';


function getTimeWithLocalZoneAbbr(value, useFromNowFormat) {
    let time;

    if (typeof value == 'number') // unix timestamp
        time = moment.unix(value);
    else if (moment(value).isValid) // date string
        time = moment(value);
    else if (!(moment.isDate(value) || moment.isMoment(value))) // date or moment
        throw new Error(`value: ${value} must be a Date or a Moment`);
    
    let zone = moment.tz.guess();
    let zoneAbbr = moment.tz(zone).zoneAbbr();

    time = time.format('M/D/YYYY LT');

    if (useFromNowFormat)
        time = time.fromNow();

    return time + ' ' + zoneAbbr;
}

function getTextForSyncCard(hasEverRan, lastSuccessfulTime, isActive) { 
    if (!hasEverRan)
    {
        if (isActive)
            return 'Running';

        return 'Never ran';
    }

    if (lastSuccessfulTime === undefined || lastSuccessfulTime === null || lastSuccessfulTime === 0) { //backend is sending back the start of the unix epoch if there is no successful run, but it ends up as zero in the frontend
        return 'No successful run'
    }

    return getTimeWithLocalZoneAbbr(lastSuccessfulTime);
}

function getRuntimeTextForSyncCard(mostRecentDuration, isActive) {
    let runTime = '';
    
    if (mostRecentDuration !== undefined && mostRecentDuration !== null && mostRecentDuration !== '') {
        runTime = getDurationDisplay(mostRecentDuration);

        if ((runTime === 'Invalid date' || runTime === '00:00:00') && isActive)
            runTime = 'None'

        if (isActive)
            runTime += ' (Running)';
    }

    return runTime;
}

const getSyncCardText = (hasEverRan, lastSuccessfulTime, mostRecentDuration, isActive) => {
    let text = getTextForSyncCard(hasEverRan, lastSuccessfulTime, isActive);
    let runtimeText = getRuntimeTextForSyncCard(mostRecentDuration, isActive);

    if (text !== '' && text !== 'Never ran') {
        text = `Last Successful: ${text}`;
    }

    if (runtimeText === 'Invalid date') {
        runtimeText = '';
    }

    if (runtimeText !== '') {
        runtimeText = `Latest Attempt Duration: ${runtimeText}`;
    }

    return (
        <div className="info-box-content">
            <span>{text}</span>
            <br />
            <span>{runtimeText}</span>
        </div>
    )
}

export { getTimeWithLocalZoneAbbr, getTextForSyncCard, getRuntimeTextForSyncCard, getSyncCardText };

// This is kinda gross, but it looks like I can't format the duration with this package in a way that rolls over hours when over 24 so I have to do it here
function getDurationDisplay(mostRecentDuration) {
    let durationInMs = moment.duration(mostRecentDuration).asMilliseconds();
    let hours = Math.abs(parseInt(durationInMs / 3600000));
    let minutes = Math.abs(parseInt((durationInMs % 3600000) / 60000));
    let seconds = Math.abs(parseInt(((durationInMs % 3600000) % 60000) / 1000));

    const isNegative = durationInMs < 0;

    // Add leading zeros to single digit values
    if (hours < 10)
        hours = '0' + hours;

    if (minutes < 10)
        minutes = '0' + minutes;

    if (seconds < 10)
        seconds = '0' + seconds;

    let runTime = `${hours}:${minutes}:${seconds}`;

    if (isNegative)
        runTime = '-' + runTime;

    return runTime;
}
